import React, { Component } from "react";
import PropTypes from "prop-types";
import { withFormsy } from "formsy-react";
import Select from "react-select";
import animated from "react-select/lib/animated";

import { Row, Col } from "react-bootstrap";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { IoSparkles } from "react-icons/io5";

import find from "lodash/find";

export const DropdownSearchSelect = ({
  name,
  label,
  data,
  placeholder,
  required,
  disabled,
  className,
  onChange,
  fieldLabel,
  value,
  isSearchable,
  isClearable,
  errorMessage,
  isOptionDisabled
}) => (
  <Row className="form-group">
    {label && (
      <Col sm={12}>
        <label
          className={`control-label ${!label ? "hidden" : ""}`}
          htmlFor={name}
          style={{ textTransform: "uppercase" }}
        >
          {fieldLabel}
        </label>
      </Col>
    )}
    <Col sm={12}>
      <Select
        className={`${className} react-select-container`}
        classNamePrefix="react-select-container"
        errorText
        required={required}
        name={name}
        value={value}
        onChange={(v) => onChange(name, v)}
        options={data}
        placeholder={placeholder || "Please Select..."}
        isSearchable={isSearchable}
        isClearable={isClearable}
        isDisabled={disabled}
        isOptionDisabled={isOptionDisabled}
      />
      {errorMessage && <small style={{ color: "red" }}>{errorMessage}</small>}
    </Col>
  </Row>
);

DropdownSearchSelect.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  data: PropTypes.object,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
  fieldLabel: PropTypes.string,
  value: PropTypes.object,
  isSearchable: PropTypes.bool,
  isClearable: PropTypes.bool,
  errorMessage: PropTypes.string,
  isOptionDisabled: PropTypes.bool
};

DropdownSearchSelect.defaultProps = {
  isSearchable: true,
  isClearable: false,
  errorMessage: null,
  isOptionDisabled: false
};

class DropdownSearch extends Component {
  constructor(props) {
    super(props);
    const obj = find(props.data, { value: props.value });
    this.state = { value: obj };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.data !== this.props.data ||
      nextProps.value !== this.props.value
    ) {
      const obj = find(nextProps.data, { value: nextProps.value });
      this.setState({ value: obj });
    }
  }

  render() {
    let {
      name,
      label,
      data,
      placeholder,
      required,
      disabled,
      isMulti,
      className,
      isExpenseStatus,
      isLoading,
      styles,
      rowClassNames,
      rowStyles,
      isOptionDisabled,
      isClearable,
      tooltipId,
      tooltipClassName,
      dataTooltipVariant,
      aiGeneratedValue,
      isNightMode,
      menuPortalTarget
    } = this.props;

    const fieldLabel = required && !disabled ? (label += " *") : label;

    return (
      <Row className={rowClassNames} style={rowStyles}>
        {this.props.label && (
          <Col sm={12}>
            <label
              className={`control-label ${!label ? "hidden" : ""}`}
              htmlFor={name}
              style={{ textTransform: "uppercase" }}
            >
              {aiGeneratedValue &&
              aiGeneratedValue === this.state.value?.value ? (
                <>
                  <IoSparkles
                    style={{
                      color: isNightMode ? "#c489dc" : "#4c53d6",
                      marginRight: "2px"
                    }}
                    id={`${label}-ai-icon`}
                    data-tooltip-variant={isNightMode ? "dark" : "light"}
                  />
                  <ReactTooltip
                    id="ai-icon-tooltip"
                    place="right"
                    effect="solid"
                    anchorId={`${label}-ai-icon`}
                    className={`custom-tooltip ${
                      isNightMode ? "dark" : "light"
                    }`}
                  >
                    <span style={{ textTransform: "none" }}>AI Generated</span>
                  </ReactTooltip>
                </>
              ) : null}
              {fieldLabel}
            </label>
          </Col>
        )}
        <Col sm={12}>
          <Select
            id={tooltipId}
            dataTooltipVariant={dataTooltipVariant}
            styles={styles}
            isLoading={isLoading}
            className={`${className} react-select-container`}
            classNamePrefix="react-select-container"
            components={animated()}
            errorText
            ref={(s) => (this.select = s)}
            required={required}
            name={name}
            value={
              isMulti || isExpenseStatus
                ? this.props.value
                : this.state.value || ""
            }
            // value={this.props.value}
            onChange={(value) => this.props.onChange(name, value)}
            options={data}
            placeholder={placeholder || "Please Select..."}
            validations="isExisty"
            validationErrors={{ isExisty: "Error" }}
            isSearchable
            isMulti={isMulti}
            isClearable={isClearable}
            isDisabled={disabled}
            isOptionDisabled={isOptionDisabled}
            menuPortalTarget={menuPortalTarget}
            // menuIsOpen={true}
          />
          {tooltipId ? (
            <ReactTooltip
              anchorId={tooltipId}
              className={tooltipClassName}
              place="top"
              type="light"
              effect="solid"
            >
              <div>Please select a Service</div>
            </ReactTooltip>
          ) : null}
        </Col>
      </Row>
    );
  }
}

DropdownSearch.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  data: PropTypes.array,
  required: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.number,
    PropTypes.object
  ]),
  placeholder: PropTypes.string,
  isMulti: PropTypes.bool,
  className: PropTypes.string,
  isExpenseStatus: PropTypes.bool,
  isLoading: PropTypes.bool,
  styles: PropTypes.object,
  rowClassNames: PropTypes.string,
  rowStyles: PropTypes.object,
  isOptionDisabled: PropTypes.bool,
  isClearable: PropTypes.bool,
  menuPortalTarget: PropTypes.object,
  tooltipId: PropTypes.string,
  tooltipClassName: PropTypes.string,
  dataTooltipVariant: PropTypes.string,
  aiGeneratedValue: PropTypes.string,
  isNightMode: PropTypes.bool
};

DropdownSearch.defaultProps = {
  isLoading: false,
  styles: {},
  rowClassNames: "form-group",
  rowStyles: {},
  isOptionDisabled: false,
  isClearable: false,
  menuPortalTarget: null,
  tooltipId: "",
  tooltipClassName: "",
  dataTooltipVariant: "",
  aiGeneratedValue: "",
  isNightMode: false
};

export { DropdownSearch as DropdownSearchWithNoFormsy };

export default withFormsy(DropdownSearch);
